<template>
  <div class="cp-auth-container">
    <div class="cp-auth-box">
      <div class="spinner" v-show="status === 'loading'"></div>
      <div class="fail-icon" v-show="status === 'fail'"></div>
      <p class="text" v-show="status === 'loading'">正在验证身份，请稍候…</p>
      <p class="text fail" v-show="status === 'fail'">{{ tip }}</p>
      <p class="sub" v-show="status === 'fail'">{{ subTip }}</p>
    </div>
  </div>
</template>

<script>
import common from "@common/common";
import dc from "@common/dc";
import { apis } from "@common/config";

export default {
  name: "cpMiddleAuth",
  data() {
    return {
      status: "loading",
      tip: "",
      subTip: ""
    };
  },
  methods: {
    writeLoginInfo(data) {
      // 与登录页一致：免登成功后写入 uid/unid，路由守卫与接口签名都依赖这两个 cookie
      if (!data || !data.uid || !data.unid) {
        return;
      }

      common.setCookie({
        name: common.UK(),
        value: data.uid,
        expires: 1,
        path: "/"
      });
      common.setCookie({
        name: common.UNK(),
        value: data.unid,
        expires: 1,
        path: "/"
      });
    },
    fail(msg, path, subTip) {
      // 提示语只在页面内展示，不再 toast
      this.status = "fail";
      this.tip = msg || "鉴权失败";
      this.subTip = subTip;
      setTimeout(() => {
        common.jump(path);
      }, 2000);
    },
    fastLogin() {
      const token = this.$route.query.token || "";
      const id = this.$route.query.id || "";

      if (!token || !id) {
        this.fail("缺少鉴权参数", "/login", "即将跳转至登录页");
        return;
      }

      common
        .myFetch(apis.Usr_fast_login_redirect, {
          method: "post",
          needLogin: false,
          // 接口约定：uid/unid 不参与签名（已登录用户残留身份也不能混进验签串）
          noUid: true,
          data: {
            token: token,
            content_id: id
          }
        })
        .then((data) => {
          if (data && data.fastLoginFail) {
            // 10001 跳登录页，10002 跳首页，提示语用接口返回的
            const toLogin = data.code === 10001;
            this.fail(
              data.msg,
              toLogin ? "/login" : "/index",
              toLogin ? "即将跳转至登录页" : "即将跳转至首页"
            );
            return;
          }

          if (data) {
            // 免登成功：清掉旧账号缓存并写入新登录态，再进素材详情页
            dc.delUsrInfo();
            this.writeLoginInfo(data);
            common.jump("/unifiedContentLibrary/content/detail/" + id);
          } else {
            this.fail("鉴权失败，请稍后重试", "/login", "即将跳转至登录页");
          }
        });
    }
  },
  mounted() {
    this.fastLogin();
  }
};
</script>

<style lang="less" scoped>
.cp-auth-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100vh;
  background: #f3f4f6;

  .cp-auth-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 48px;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 8px 0 rgba(5, 10, 15, 0.06);

    .spinner {
      width: 32px;
      height: 32px;
      border: 3px solid #dce4f5;
      border-top-color: #2269ff;
      border-radius: 50%;
      animation: cp-auth-rotate 0.8s linear infinite;
      margin-bottom: 18px;
    }

    .fail-icon {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      background: #fdebeb;
      color: #f56c6c;
      font-size: 22px;
      line-height: 32px;
      text-align: center;
      font-weight: bold;
      margin-bottom: 18px;

      &::before {
        content: "!";
      }
    }

    .text {
      font-size: 15px;
      color: #323b4b;
      line-height: 1.5;
    }

    .fail {
      color: #f56c6c;
    }

    .sub {
      margin-top: 8px;
      font-size: 13px;
      color: #829191;
    }
  }
}

@keyframes cp-auth-rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
